module.exports = __webpack_public_path__ + "img/2-1.11235299.png";